<template>
  <div v-if="render" class="main-page-box">
    <div class="back-box" @click="back">
      <i class="fas fa-chevron-left fa-fw"></i>
      BACK
    </div>

    <div class="d-flex align-start d-split">
      <payment-form ref="paymentForm" class="payment-form-box"
      ></payment-form>

      <div class="price-box-wrap">
        <div class="price-box page-box">
          <div class="price-label">Best Price From</div>
          <div class="price-value">
            <!-- ${{ (view.Price.TotalDisplayFare / currency.list[view.Price.Currency]).toFixed(2) }} -->
             ${{ discount(view.Price, 35).discounted }}
          </div>
          <a class="lr-btn" @click="submit">Submit</a>
        </div>
        <div class="cxl-box page-box" v-if="view.Cancellation_available">
          <div class="page-label">Cancellation Policy</div>
          <div class="cxl-desc">{{ view.Cancellation_Policy }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paymentForm from '@/components/D2DReview/PaymentForm'

export default {
  name: 'review-page',
  components: { paymentForm },
  data () {
    return {
      render: false
    }
  },
  computed: {
    things () { return this.$store.state.things },
    view () { return this.things.view },
    currency () { return this.$store.state.other.currency }
  },
  methods: {
    back () {
      this.$router.push('/things/view')
    },
    submit () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})
      setTimeout(() => {
        self.$router.push('/things/thankyou')
      }, 1500)
    },
    discount (data, x) {
      let price = data.TotalDisplayFare / this.currency.list[data.Currency]
      let discount = price * (x / 100)
      return {
        price: price.toFixed(2),
        discount: discount.toFixed(2),
        discounted: (price - discount).toFixed(2)
      }
    }
  },
  mounted () {
    this.render = false
    if (!this.things.view) {
      this.back()
      return
    }
    this.render = true
  }
}
</script>

<style lang="scss" scoped>
.main-page-box{
  // background: #fafafa;
  // border: 1px solid #ddd;
  // padding: 15px 20px;
  margin-bottom: 20px;
}
.back-box{
  color: #ff9c09;
  letter-spacing: .7px;
  margin-bottom: 20px;
  cursor: pointer;
}

.d-split{
  gap: 20px;
}

.price-value{
  font-size: 28px;
  font-weight: 600;
  letter-spacing: .7px;
  line-height: 1;
  margin-bottom: 20px;
}

.page-box{
  background: #fff;
  border: 1px solid #ddd;
  padding: 15px 20px;
}
.page-label{
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 10px;
  letter-spacing: .7px;
}
.page-desc{
  color: #455c72;
  line-height: 1.4;
}

.price-box{
  width: 350px;

  .lr-btn{
    width: 100%;
    display: block;
  }
}
.price-label{
  font-size: 15px;
  color: #888;
  letter-spacing: .7px;
  line-height: 1;
  margin-bottom: 5px;
}

.cxl-box{
  margin-top: 10px;
  width: 350px;
}
.cxl-desc{
  line-height: 1.5;
  font-size: 14px;
  color: #777;
  letter-spacing: .6px;
}


@media only screen and (max-width: 641px) {
  .back-box{
    padding-left: 15px;
  }
  .d-split{
    flex-direction: column;
    padding: 0 15px;
    gap: 0;
  }
  .price-box-wrap,
  .price-box,
  .cxl-box{
    width: 100%
  }
}
</style>


// WEBPACK FOOTER //
// review.vue?1ba2db10